<template>
  <div class="slider-form" :class="{ 'slider-form--region': slideNo === 2}">
    <transition name="slide-next">
      <div class="slider-form__item" v-if="slideNo === 1">
        <h3 class="slider-form__header">What type of email do you want to send?</h3>

        <div class="radio-container radio-container--type">
          <div class="radio-group radio-group--type" :class="{ 'radio-group--active': emailType === 'Available property' }" @click="submitType('Available property')">
            <input type="radio" id="available_property" name="type" value="Available property" v-model="emailType">
            <label for="available_property" :class="{ 'active': emailType === 'Available property' }">
              <i class="icon-home" :class="{ 'icon-home--active': emailType === 'Available property' }"></i>
              <span>Available property</span>
            </label>
          </div>
          <div class="radio-group radio-group--type" :class="{ 'radio-group--active': emailType === 'Village promotion' }" @click="submitType('Village promotion')">
            <input type="radio" id="village_promotion" name="type" value="Village promotion" v-model="emailType">
            <label for="village_promotion" :class="{ 'active': emailType === 'Village promotion' }">
              <i class="icon-horn" :class="{ 'icon-horn--active': emailType === 'Village promotion' }"></i>
              <span>Village promotion</span>
            </label>
          </div>
          <div class="radio-group radio-group--type" :class="{ 'radio-group--active': emailType === 'Open day' }" @click="submitType('Open day')">
            <input type="radio" id="open_day" name="type" value="Open day" v-model="emailType">
            <label for="open_day" :class="{ 'active': emailType === 'Open day' }">
              <i class="icon-cup" :class="{ 'icon-cup--active': emailType === 'Open day' }"></i>
              <span>Open day</span>
            </label>
          </div>
        </div>
      </div>
    </transition>
    <transition name="slide-next">
      <div class="slider-form__item" v-if="slideNo === 2">
        <h3 class="slider-form__header">What region do you want to target?</h3>

        <div class="radio-container radio-container--region">
          <div class="radio-group radio-group--region" :class="{ 'radio-group--active': regionInput === region.name }" @click="submitRegion(region.name)" v-for="region in regions">
            <input type="radio" :id="region.name" name="type" :value="region.name" v-model="regionInput">
            <label :for="region.name" :class="{ 'active': regionInput === region.name }">
              <span>{{ region.name }}</span>
            </label>
          </div>
        </div>
      </div>
    </transition>
    <transition name="slide-next">
      <div class="slider-form__item" v-if="slideNo === 3">
        <h3 class="slider-form__header">When do you want the email sent?</h3>

        <div class="radio-container radio-container--type">
          <div class="radio-group radio-group--type" :class="{ 'radio-group--active': emailSentTime === 'As soon as possible' }" @click="submitEmailTime('As soon as possible')">
            <input type="radio" id="email_send_soon" name="when" value="As soon as possible" v-model="emailSentTime">
            <label for="email_send_soon" :class="{ 'active': emailSentTime === 'As soon as possible' }">
              <i class="icon-send" :class="{ 'icon-send--active': emailSentTime === 'As soon as possible' }"></i>
              <span>As soon as possible</span>
            </label>
          </div>
          <div class="radio-group radio-group--type" :class="{ 'radio-group--active': emailSentTime === 'Next week' }" @click="submitEmailTime('Next week')">
            <input type="radio" id="email_send_next_week" name="when" value="Village promotion" v-model="emailSentTime">
            <label for="email_send_next_week" :class="{ 'active': emailSentTime === 'Next week' }">
              <i class="icon-calendar" :class="{ 'icon-calendar--active': emailSentTime === 'Next week' }"></i>
              <span>Next week</span>
            </label>
          </div>
          <div class="radio-group radio-group--type" :class="{ 'radio-group--active': emailSentTime === '1-3 weeks' }" @click="submitEmailTime('1-3 weeks')">
            <input type="radio" id="email_send_2_weeks" name="when" value="1-3 weeks" v-model="emailSentTime">
            <label for="email_send_2_weeks" :class="{ 'active': emailSentTime === '1-3 weeks' }">
              <i class="icon-hourglass" :class="{ 'icon-hourglass--active': emailSentTime === '1-3 weeks' }"></i>
              <span>1-3 weeks</span>
            </label>
          </div>
        </div>
      </div>
    </transition>
    <Form
      method="POST"
      class="ml-auto mr-auto"
      :validation-schema="validationSchema"
      v-slot="{ errors }"
      @submit="sendEnquiry"
      id="careHomeHelp"
    >
      <transition name="slide-next">
        <div class="slider-form__item" v-if="slideNo === 4">
          <h3 class="slider-form__header">What is your email address?</h3>
          <label for="email" class="sr-only">Email</label>
          <Field
            id="email"
            v-model="inputEmail"
            type="email"
            placeholder="Your email address ..."
            class="form-control slider-form__input"
            :class="{'is-danger': errors['email'] }"
            name="email"
          />
          <ErrorMessage name="email" class="is-danger" />
          <button name="next" class="btn btn--green" type="submit">Next step</button>
        </div>
      </transition>
      <transition name="slide-next">
        <div class="slider-form__item" v-if="slideNo === 5">
          <h3 class="slider-form__header">Thank you, what is your name?</h3>
          <label for="yourname" class="sr-only">Name</label>
          <Field
            id="yourname"
            v-model="inputName"
            type="text"
            placeholder="Your name ..."
            class="form-control slider-form__input"
            :class="{'is-danger': errors['yourname'] }"
            name="yourname"
          />
          <ErrorMessage name="yourname" class="is-danger" />
          <button name="next" class="btn btn--green" type="submit">Send enquiry</button>
        </div>
      </transition>
    </Form>
    <transition name="slide-next">
      <div class="slider-form__item" v-if="slideNo === 6">
        <div class="slider-form__success-round"><i class="icon icon--tick"></i></div>
        <h3 class="slider-form__header">Your enquiry was submitted successfully, <br>we’ll be in touch soon.</h3>
      </div>
    </transition>
    <a href="#" @click.prevent="back" v-if="slideNo > 1 && slideNo < 6" class="slider-form__back-link">Back</a>
    <div class="slider-form__progress-light-green">
      <div class="slider-form__progress-green" :style="{ width: percentage + '%' }"></div>
    </div>
  </div>
</template>

<script setup>
import {computed, ref, watch} from 'vue'
import axios from 'axios'
import {ErrorMessage, Field, Form} from 'vee-validate'

const emailType = ref('')
const regionInput = ref('')
const emailSentTime = ref('')
const inputEmail = ref('')
const inputName = ref('')
const slideNo = ref(1)
const percentage = ref(20)
const regions = ref([
  {name: 'Northland'},
  {name: 'Auckland'},
  {name: 'Waikato'},
  {name: 'Bay of Plenty'},
  {name: 'Gisborne'},
  {name: 'Hawke\'s Bay'},
  {name: 'Taranaki'},
  {name: 'Manawatu / Wanganui'},
  {name: 'Wellington'},
  {name: 'Nelson / Tasman'},
  {name: 'Marlborough'},
  {name: 'West Coast'},
  {name: 'Canterbury'},
  {name: 'Otago'},
  {name: 'Southland'},
])

const validationSchema = computed(() => {
  let schema = {}

  if (slideNo.value === 4) {
    schema.email = 'required|email'
  }

  if (slideNo.value === 5) {
    schema.yourname = 'required'
  }

  return schema
})

watch(
  () => slideNo.value,
  (newSlideNo) => {
    calculatePercentage();
  }
);

  const submitType = (value) => {
    emailType.value = value
    slideNo.value = 2
    calculatePercentage()
  }

  const submitRegion = (value) => {
    regionInput.value = value
    slideNo.value = 3
    calculatePercentage()
  }

  const submitEmailTime = (value) => {
    emailSentTime.value = value
    slideNo.value = 4
    calculatePercentage()
  }

  const sendEnquiry = () => {
    if (slideNo.value !== 5) {
      slideNo.value = slideNo.value + 1;
    } else {
      slideNo.value = 6
      calculatePercentage()

      axios.post('/send-edm-email', {
        type: emailType.value,
        region: regionInput.value,
        when: emailSentTime.value,
        email: inputEmail.value,
        name: inputName.value,
        _token: document.head.querySelector("[name~=csrf-token][content]").content,
      }).then(function (response) {})
    }
    // Vue.$validator.validateAll().then((result) => {
    //   if (result) {
    //     slideNo.value = 6
    //     calculatePercentage()
    //
    //     axios.post('/send-edm-email', {
    //       type: emailType.value,
    //       region: regionInput.value,
    //       when: emailSentTime.value,
    //       email: inputEmail.value,
    //       name: inputName.value,
    //       _token: document.head.querySelector("[name~=csrf-token][content]").content,
    //     }).then(function (response) {})
    //   }
    // })
  }

  const back = () => {
    slideNo.value = slideNo.value - 1
    calculatePercentage()
  }

  const calculatePercentage = () => {
    percentage.value = (slideNo.value * 16.66)
  }

</script>
